import PropTypes from "prop-types";
import "./statusDot.scss";
function CcassstatusDot(props: any) {
  let { className, ...restProps } = props;
  return (
    <>
      <span className={className}></span>
    </>
  );
}

export { CcassstatusDot };

CcassstatusDot.propTypes = {
  className: PropTypes.any,
};
